import React from 'react'

const BatsmanRowHeader = () => {
    return (
        <>
            <div className='scorecard-row row-header'>
                <div className="rh1">
                    Batsman
                </div>
                <div className="rh2">
                    R
                </div>
                <div className="rh2">
                    B
                </div>
                <div className="rh3" >
                    4s
                </div>
                <div className="rh3">
                    6s
                </div>
                <div className="rh4">
                    S/R
                </div>
            </div>
            <div className="shortrow" />
        </>
    )
}

const BowlerRowHeader = () => {
    return (
        <>
            <div className='scorecard-row row-header'>
                <div className="rh1">
                    Bowler
                </div>
                <div className="rh2">
                    O
                </div>
                <div className="rh2">
                    M
                </div>
                <div className="rh3" >
                    R
                </div>
                <div className="rh3">
                    W
                </div>
                <div className="rh4">
                    Eco
                </div>
            </div>
            <div className="shortrow"></div>
        </>
    )
}


const FowRowHeader = () => {
    return (
        <>
            <div className='scorecard-row row-header'>
                <div className="rh6">
                    Fall of wickets
                </div>
                <div className="rh7">
                    Score
                </div>
                <div className="rh7">
                    over
                </div>
            </div>
            <div className="shortrow"></div>
        </>
    )
}


export {
    BatsmanRowHeader,
    BowlerRowHeader,
    FowRowHeader
}